module.exports = __webpack_public_path__ + "static/img/img-4-7.ebc442f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-7.png
// module id = DKbD
// module chunks = 0